import { OurPhilosophyContainer, ImagePhilosophy, TextPhilosophy  } from "./OurPhilosophy.style"
import Doctors from '../../assets/philosophy.png'
import { MedicineContainer } from "../Medicine/Medicine.style"

const OurPhilosophy = () => {
    return(
        <OurPhilosophyContainer>
            <ImagePhilosophy>
                <img src={Doctors} />
            </ImagePhilosophy>
            <TextPhilosophy>
                <h1>Nuestra filosofía</h1>
                <p>Trascendiendo en cada iniciativa que emprendemos,  nos esforzamos constantemente por posicionarnos como líderes en nuestros sectores. Buscamos contribuir de manera
                    significativa a la salud, el bienestar y el
                    cuidado integral, ofreciendo productos de
                    la más alta calidad. 
                <br/>
                <br/>
                Atendemos diferentes sectores del mercado y en cada uno de ellos nos especializamos en ofrecer y cubrir las necesidades que cada uno de ellos demandan:</p>
            </TextPhilosophy>
        </OurPhilosophyContainer>
    )
}

export default OurPhilosophy